import { API_STATUS } from '@/Common/Enum/ApiStatus.js';
import { NIGHTCRAWLER_CHECK_STATUS } from '@/Common/Classifiers/NightcrawlerCheckClassifier.js';
import i18n from '@/Plugins/i18n.js';

const t = (key) => i18n.global.t(`common.action_types.${key}`);

// Create action type objects with getter for tooltip to enable dynamic translation
const createActionType = (color, icon, tooltipKey) => ({
  color,
  icon,
  get tooltip() {
    return t(tooltipKey);
  }
});

export const ACTION_TYPES = {
  ACTION_REQUIRED: createActionType('danger', 'cross', 'action_required'),
  ACTION_RECOMMENDED: createActionType(
    'warning',
    'exclaim',
    'action_recommended'
  ),
  ACTION_OPTIONAL: createActionType('info', 'info', 'action_optional'),
  NO_ACTION: createActionType('success', 'check', 'no_action'),
  NO_ACTION_WITH_DEFAULT: createActionType(
    'success',
    'check',
    'no_action_with_default'
  ),
  INFO: createActionType('info', 'info', 'information'),
  INFO_WARN: createActionType('warning', 'info', 'information'),
  INFO_ERROR: createActionType('danger', 'info', 'information'),
  INFO_DEFAULT: createActionType('default', 'info', 'information')
};

export function getActionTypeFromStatus(status) {
  switch (status) {
    case API_STATUS.OK:
    case NIGHTCRAWLER_CHECK_STATUS.OK:
      return ACTION_TYPES.NO_ACTION;
    case API_STATUS.INFO:
    case NIGHTCRAWLER_CHECK_STATUS.INFO:
      return ACTION_TYPES.INFO;
    case API_STATUS.WARN:
    case NIGHTCRAWLER_CHECK_STATUS.WARN:
      return ACTION_TYPES.ACTION_RECOMMENDED;
    case API_STATUS.FAIL:
    case API_STATUS.ERROR:
    case API_STATUS.FATAL:
    case NIGHTCRAWLER_CHECK_STATUS.ERROR:
    case NIGHTCRAWLER_CHECK_STATUS.FATAL:
      return ACTION_TYPES.ACTION_REQUIRED;
  }
}

export function getActionTypeFromScore(score) {
  if (score >= 80) {
    return ACTION_TYPES.NO_ACTION;
  } else if (score >= 50) {
    return ACTION_TYPES.ACTION_RECOMMENDED;
  } else {
    return ACTION_TYPES.ACTION_REQUIRED;
  }
}

export function getActionTypeFromRating(rating) {
  if (rating < 4) {
    return ACTION_TYPES.ACTION_REQUIRED;
  } else if (rating < 5) {
    return ACTION_TYPES.ACTION_RECOMMENDED;
  } else {
    return ACTION_TYPES.NO_ACTION;
  }
}

export default ACTION_TYPES;
